import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-arvr',
  templateUrl: './arvr.component.html',
  styleUrls: ['./arvr.component.css']
})
export class ArvrComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
